export const LogoMark = ({ className = "h-6 w-6" }) => (
    <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
        <rect x="6" y="6" width="5" height="20" fill="currentColor" />
        <rect x="21" y="6" width="5" height="20" fill="currentColor" />
        <rect x="11" y="13" width="10" height="6" fill="#D92D20" />
    </svg>
);

export default function Logo({ onClick }) {
    return (
        <button
            data-testid="logo-home-link"
            onClick={onClick}
            className="group flex items-center gap-3 text-paper transition-colors duration-300 hover:text-vermilion"
            aria-label="HVP Consultants — home"
        >
            <LogoMark className="h-7 w-7 transition-transform duration-500 group-hover:rotate-180" />
            <span className="flex flex-col items-start leading-none">
                <span className="font-display text-xl md:text-2xl font-medium tracking-wide">
                    HVP
                </span>
                <span className="font-mono text-[9px] tracking-[0.3em] text-smoke group-hover:text-smoke">
                    CONSULTANTS
                </span>
            </span>
        </button>
    );
}
